export default __webpack_public_path__ + "static/media/Hair_20_F_C4.ce272748.svg";